// extracted by mini-css-extract-plugin
export var header = "header-module--header--UabsJ";
export var titleContainer = "header-module--titleContainer--t73WB";
export var titleBg = "header-module--titleBg--pEOZT";
export var titleText = "header-module--titleText--LVicm";
export var navList = "header-module--navList--zbv+F";
export var navItem = "header-module--navItem---g1En";